import React from "react";
import { Box, Card, CardContent, Typography, Grid, Chip, Button, GlobalStyles, Stepper, Step, StepLabel } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ShoppingCart as ShoppingCartIcon, Home as HomeIcon, Receipt as ReceiptIcon, LocalShipping, CheckCircle } from "@mui/icons-material";
import { useAuth } from "../../AuthProvider";

const ordersData = [
  {
    id: "ORD10234",
    product: "Classroom Bench",
    price: "₹3,500",
    quantity: 2,
    status: "Delivered",
    date: "10 Mar 2026",
    img: "https://images.unsplash.com/photo-1580582932707-520aed937b7b",
    address: "School Name, City, State, PIN",
    tracking: "TRK123456789",
  },
  {
    id: "ORD10235",
    product: "WiFi Router",
    price: "₹3,200",
    quantity: 1,
    status: "Shipped",
    date: "09 Mar 2026",
    img: "https://images.unsplash.com/photo-1580894894513-6c7a47b3f6b3",
    address: "School Name, City, State, PIN",
    tracking: "TRK987654321",
  },
  {
    id: "ORD10236",
    product: "Printer",
    price: "₹14,200",
    quantity: 1,
    status: "Processing",
    date: "08 Mar 2026",
    img: "https://images.unsplash.com/photo-1593642532400-2682810df593",
    address: "School Name, City, State, PIN",
    tracking: null,
  },
  {
    id: "ORD10237",
    product: "Football",
    price: "₹1,500",
    quantity: 5,
    status: "Delivered",
    date: "07 Mar 2026",
    img: "https://images.unsplash.com/photo-1546519638-68e109498ffc",
    address: "School Name, City, State, PIN",
    tracking: "TRK456789123",
  },
];

const Orders = () => {
  const navigate = useNavigate();
  const { oId, board, userId, role, pId } = useAuth();

  const getSteps = (status) => {
    const allSteps = ["Ordered", "Processing", "Shipped", "Delivered"];
    let activeStep = 0;
    if (status === "Processing") activeStep = 1;
    else if (status === "Shipped") activeStep = 2;
    else if (status === "Delivered") activeStep = 3;
    return { steps: allSteps, activeStep };
  };
  return (
    <Box sx={{ mt: 7, mx: 2 }}>
      <Card
        sx={{
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          backgroundColor: "#fff",
          minHeight: "500px",
          display: "flex",
          flexDirection: "column",
          width: "100%",
          maxWidth: "1200px",
          mx: "auto",
          overflowX: "hidden",
        }}
      >
        <CardContent>
          {/* header */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
              padding: "10px 18px",
              background: "rgba(255,255,255,0.75)",
              backdropFilter: "blur(12px)",
              borderBottom: "1px solid rgba(0,0,0,0.05)",
              boxShadow: "0 8px 30px rgba(0,0,0,0.04)",
              position: "sticky",
              top: 0,
              zIndex: 1000,
            }}
          >
            {/* LOGO */}
            <Box
              sx={{
                fontSize: "20px",
                fontWeight: 800,
                background: "linear-gradient(135deg,#4f5cf1,#7b85ff)",
                color: "#fff",
                px: 2,
                py: 0.6,
                borderRadius: "10px",
                cursor: "pointer",
                boxShadow: "0 8px 20px rgba(79,92,241,.35)",
              }}
            >
              MapEdu
            </Box>

            {/* HOME */}
            <Box
              onClick={() => navigate("/Marketing")}
              sx={{
                fontSize: "14px",
                fontWeight: 700,
                cursor: "pointer",
                px: 2,
                py: 1,
                borderRadius: "10px",
                color: "#1d1d1f",
                background: "transparent",
                transition: "0.25s",
                display: 'flex', alignItems: 'center', gap: 0.5,
                "&:hover": {
                  background: "rgba(79,92,241,0.15)",
                  color: "#4f5cf1",
                },
              }}
            >
              <HomeIcon fontSize="small" /> Home
            </Box>

            {/* SEARCH BAR */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                background: "#f1f3ff",
                borderRadius: "12px",
                px: 2,
                py: 0.5,
                maxWidth: "600px",
                transition: "0.3s",
                "&:focus-within": {
                  boxShadow: "0 0 0 2px #4f5cf1",
                  background: "#fff",
                },
              }}
            >
              <Box sx={{ fontSize: "18px", mr: 1, color: "#4f5cf1" }}>🔍</Box>
              <input
                placeholder="Search schools, services, tools..."
                style={{
                  flex: 1,
                  border: "none",
                  outline: "none",
                  background: "transparent",
                  fontSize: "14px",
                }}
              />
            </Box>

            {/* SHOP */}
            <Box
              onClick={() => navigate("/shop")}
              sx={{
                fontSize: "14px",
                fontWeight: 600,
                cursor: "pointer",
                px: 2,
                py: 1,
                borderRadius: "10px",
                color: "#1d1d1f",
                background: "transparent",
                transition: "0.3s",
                display: 'flex', alignItems: 'center', gap: 0.5,
                "&:hover": {
                  background: "#f1f3ff",
                  color: "#4f5cf1",
                },
              }}
            >
              <ShoppingCartIcon fontSize="small" /> Shop
            </Box>

            {/* ORDERS */}
            <Box
              onClick={() => navigate("/order")}
              sx={{
                fontSize: "14px",
                fontWeight: 600,
                cursor: "pointer",
                px: 2,
                py: 1,
                borderRadius: "10px",
                color: "#1d1d1f",
                background: "transparent",
                transition: "0.3s",
                display: 'flex', alignItems: 'center', gap: 0.5,
                "&:hover": {
                  background: "#f1f3ff",
                  color: "#4f5cf1",
                },
              }}
            >
              <ReceiptIcon fontSize="small" /> Orders
            </Box>

            {/* LOGIN */}
            <Button
              variant="contained"
              sx={{
                background: "linear-gradient(135deg,#4f5cf1,#7b85ff)",
                color: "#fff",
                borderRadius: "12px",
                px: 3,
                py: 1,
                fontWeight: 700,
                boxShadow: "0 10px 30px rgba(79,92,241,.4)",
                textTransform: "none",
                "&:hover": {
                  transform: "translateY(-1px)",
                  boxShadow: "0 15px 40px rgba(79,92,241,.5)",
                },
              }}
            >
              Login / Register
            </Button>
          </Box>

          <Box
            sx={{
              width: "100%",
              maxWidth: "1200px",
              mx: "auto",
              overflowX: "hidden",
              minWidth: 0,
            }}
          >
            <Typography
              sx={{
                fontSize: "28px",
                fontWeight: 800,
                mb: 3,
              }}
            >
              Your Orders
            </Typography>

            <Grid container spacing={3}>
              {ordersData.map((order, index) => {
                const { steps, activeStep } = getSteps(order.status);
                return (
                  <Grid item xs={12} key={index}>
                    <Card
                      sx={{
                        borderRadius: 3,
                        p: 3,
                        transition: ".25s",
                        "&:hover": {
                          boxShadow: "0 10px 25px rgba(0,0,0,.2)",
                        },
                      }}
                    >
                      <Box sx={{ display: "flex", gap: 3, alignItems: "flex-start" }}>
                        <Box
                          component="img"
                          src={order.img}
                          sx={{
                            width: 120,
                            height: 120,
                            objectFit: "cover",
                            borderRadius: 2,
                          }}
                        />

                        <Box sx={{ flex: 1 }}>
                          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 1 }}>
                            <Box>
                              <Typography variant="h6" fontWeight={700}>
                                {order.product}
                              </Typography>
                              <Typography sx={{ color: "#b12704", fontWeight: 800, fontSize: "18px" }}>
                                {order.price} x {order.quantity}
                              </Typography>
                            </Box>
                            <Chip
                              label={order.status}
                              color={
                                order.status === "Delivered"
                                  ? "success"
                                  : order.status === "Shipped"
                                  ? "info"
                                  : "warning"
                              }
                              size="small"
                              icon={order.status === "Delivered" ? <CheckCircle /> : <LocalShipping />}
                            />
                          </Box>

                          <Typography sx={{ fontSize: 14, color: "gray", mb: 1 }}>
                            Order ID: {order.id} | Date: {order.date}
                          </Typography>

                          <Typography sx={{ fontSize: 14, color: "gray", mb: 2 }}>
                            Delivery Address: {order.address}
                          </Typography>

                          {order.tracking && (
                            <Typography sx={{ fontSize: 14, color: "gray", mb: 2 }}>
                              Tracking Number: {order.tracking}
                            </Typography>
                          )}

                          <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 2 }}>
                            {steps.map((label) => (
                              <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                              </Step>
                            ))}
                          </Stepper>

                          <Box sx={{ display: "flex", gap: 2 }}>
                            <Button variant="outlined" size="small">
                              View Details
                            </Button>
                            <Button variant="contained" size="small">
                              Track Order
                            </Button>
                            <Button variant="text" size="small">
                              Reorder
                            </Button>
                          </Box>
                        </Box>
                      </Box>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>

            <GlobalStyles
              styles={{
                ".custom-sidebar-scrollbar": {
                  scrollbarWidth: "thin",
                  scrollbarColor: "grey #e0e0e0",
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                  width: "6px",
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                  backgroundColor: "grey",
                  borderRadius: "10px",
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                  backgroundColor: "#555",
                },
              }}
            />
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Orders;